/**
 * Live feedback: the rules the player's own expression already breaks, read from the public
 * numbers and flags only. Never "wrong total" or "numbers left": typing may still fix those.
 */
import type { Feedback } from "../types";
import { liveReading } from "./progress";
import type { CountdownDefinition, CountdownProgress } from "./types";

export function localFeedback(
  definition: CountdownDefinition,
  progress: CountdownProgress,
): Feedback[] {
  return liveReading(definition, progress).issues.map(({ code, params }) => ({
    type: "countdown",
    code,
    cells: [],
    params,
  }));
}
